import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-single',
  templateUrl: './sidebar-single.component.html',
  styleUrls: ['./sidebar-single.component.scss']
})
export class SidebarSingleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
